<template>
  <div class="patients">
    <v-overlay :value="loading" z-index="4">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <main-user-table
      :headers="headers"
      :items="bhUserPatients.participants"
      :items-per-page="queryParams.pageSize"
      :server-items-length="pagination.totalCount || -1"
      :page="queryParams.page"
      :row-component="'bh-patient-table-row'"
      @to-user="toPatient"
      @action:get-data="getDataAction"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RouterMixin from '@/mixins/router'
import MainUserTable from '@/components/tables/MainUserTable'

export default {
  name: 'BhUserPatients',
  components: {
    MainUserTable,
  },
  data() {
    return {
      headers: [
        { sortable: false },
        { text: 'Name', value: 'fullName' },
        { text: 'Join date', value: 'creationDate' },
        { text: 'Last updated swap', value: 'lastUpdatedSwaps' },
        { text: 'Most recent activity ', value: 'lastActivity' },
        { text: 'Phone no.', value: 'phone', sortable: false },
        { text: 'Notes', value: 'notes', sortable: false },
      ],
    }
  },
  mixins: [RouterMixin],
  computed: {
    ...mapState('bhUsersStates', ['bhUserPatients', 'loading', 'pagination']),
    bhUserId() {
      return this.$route.params.id
    },
  },
  methods: {
    ...mapActions('bhUsersStates', ['getBhUserPatients']),
    toPatient(id) {
      this.$router.push({
        name: 'Patient',
        path: '/participants/:id',
        params: { id: id },
      })
    },
    getData(data) {
      this.getBhUserPatients(this.bhUserId, data)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.patients {
  padding: 32px;
}
</style>
